// frontend/src/config.js
export const API_URL = "https://wolfmind-backend-q6lx.onrender.com/api";
